module.exports = __webpack_public_path__ + "img/check.32ae3deb.svg";